function binary () {
    var mainGrid = document.getElementById('mainSearchGrid');
    var card = document.getElementsByClassName('card--standart');
    mainGrid.classList.remove('grid--1-col-tablet-down');
    mainGrid.classList.add('grid--2-col-tablet-down');
    $('.card-wrapper .card').removeClass('card-horizontal');
  };
  
  function single () {
    var mainGrid = document.getElementById('mainSearchGrid');
    var card = document.getElementsByClassName('card--standart');
    mainGrid.classList.remove('grid--2-col-tablet-down');
    mainGrid.classList.add('grid--1-col-tablet-down');
    $('.card-wrapper .card').addClass('card-horizontal');
    $('.card-wrapper .card').removeClass('card--standart');
  };

  var header = document.getElementById("steep");
  var colorbtn = header.getElementsByClassName("colorbtn");
  for (var i = 0; i < colorbtn.length; i++) {
    colorbtn[i].addEventListener("click", function () {
      var current = document.getElementsByClassName("online");
      current[0].className = current[0].className.replace("online", "");
      this.className += " online";
    });
  }
  function checkMobileLayoutCookie(){
    let grid_style = getMobileLayoutCookie("selectedGridLayout");
    if(grid_style != ""){
      $("."+grid_style).trigger("click")
      $("."+grid_style).partner().trigger("click");
    }
  }
  function checkDesktopLayoutCookie(){
    let grid_style = getDesktopLayoutCookie("selectedDesktopGridLayout");
    if(grid_style != ""){
      $("."+grid_style).trigger("click");
      if(grid_style =="fourtly"){
        $("#product-grid").addClass("grid--4-col-desktop").removeClass("grid--3-col-desktop");
      }
      if(grid_style =="thirtly"){
        $("#product-grid").addClass("grid--3-col-desktop").removeClass("grid--4-col-desktop");
      }
    }
  }
  window.addEventListener("DOMContentLoaded",function(){
    checkMobileLayoutCookie();
    checkDesktopLayoutCookie();
  })